var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteSecondary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.05957,
    cy: 8.91528,
    r: 8,
    fill: "#8492A3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_251_2252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2097 5.77039C11.0147 5.57539 10.6997 5.57539 10.5047 5.77039L8.05968 8.21039L5.61468 5.76539C5.41968 5.57039 5.10468 5.57039 4.90968 5.76539C4.71468 5.96039 4.71468 6.27539 4.90968 6.47039L7.35468 8.91539L4.90968 11.3604C4.71468 11.5554 4.71468 11.8704 4.90968 12.0654C5.10468 12.2604 5.41968 12.2604 5.61468 12.0654L8.05968 9.62039L10.5047 12.0654C10.6997 12.2604 11.0147 12.2604 11.2097 12.0654C11.4047 11.8704 11.4047 11.5554 11.2097 11.3604L8.76468 8.91539L11.2097 6.47039C11.3997 6.28039 11.3997 5.96039 11.2097 5.77039Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_251_2252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(2.05957 2.91528)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteSecondary);
export default __webpack_public_path__ + "static/media/deleteSecondary.52e64374d6da7cbf6924ae62f1a21ff3.svg";
export { ForwardRef as ReactComponent };